//------------------------------------------------------------------------------
// 画面設定 リデューサー
//------------------------------------------------------------------------------
import { combineReducers } from 'redux';
import types from './types';

/**
 * 地図マウスホイール設定 (ホイールで拡大/縮小)
 */
const wheelZoom = (state = true, action) => {
  return (action.type === types.WHEEL_ZOOM)
      ? action.wheelZoom
      : state;
};

// 地図アクション表示設定デフォルト
const DEF_MAP_CONFIG = {
  expandAction: false,    // 操作バーを展開
  expandSearch: false,    // 検索バーを展開
  vertical:  true,        // ボタン縦レイアウト
};

/**
 * 地図アクション表示設定
 */
const mapConfig = (state = DEF_MAP_CONFIG, action) => {
  return (action.type === types.MAP_CONFIG)
      ? { ...state, ...action.mapConfig }
      : state;
};

// エクスポート
const reducers = combineReducers({
  wheelZoom,
  mapConfig,
});
export default reducers;
